export const recipes = {
    frontend: [
        'activeServicesReport',
        'activityLog',
        'adHocInvoiceApproval',
        'agenticDrafting',
        'analystAgent',
        'agreement',
        'agreementImport',
        'agreementStudio',
        'amendments',
        'billing',
        'billingHub',
        'clientFlow',
        'common',
        'components',
        'contactSupportButton',
        'customPages',
        'dateRange',
        'errors',
        'futureInvoicesReport',
        'helpMeWrite',
        'hooks',
        'integrations',
        'invoice',
        'invoiceLogic',
        'mapServicesCallout',
        'models',
        'notificationHelpMeWrite',
        'notificationTypes',
        'notificationVariants',
        'oauth',
        'pages',
        'payouts',
        'referenceFields',
        'serviceBuilder',
        'tasksDrawer',
        'test',
        'vendorOnboarding'
    ],
    scoutPdf: [
        'activityLog',
        'adHocInvoiceApproval',
        'agreement',
        'amendments',
        'billing',
        'billingHub',
        'clientFlow',
        'common',
        'components',
        'hooks',
        'invoice',
        'models',
        'pages',
        'receipt',
        'serviceBuilder'
    ]
};
